"use client";

import React, {useState} from "react";

import {useRouter} from "next/navigation";


const SearchBar = ({storeCode,store,label}) => {

    const router = useRouter();
    const [query, setQuery] = useState('');
    const handleSubmit = (e) => {
        e.preventDefault();

        if (query.trim().length === 0)
            return false;

        //console.log(`query is ${query}`);

        const queryParsed = query.replace(new RegExp(/ /), '+');

        //console.log(`query parsed is ${queryParsed}`);

        router.push( `${store?.secure_base_link_url}catalogsearch/result?q=${queryParsed}`);
    }

    return <>
        <div className={`absolute inset-y-0 right-0 items-center pr-2 ${query.length > 0 ? 'hidden' : 'flex'}`}>
            <svg className="h-5 w-full" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                      clipRule="evenodd"/>
            </svg>
        </div>
        <form className={'w-full'} onSubmit={handleSubmit}>
            <input className="w-full text-gray-900 placeholder-gray-400 border-none rounded py-3 pl-2 pr-4 bg-white text-sm z-10 focus:outline focus:outline-[#e7bb43] "
                   type="search"
                   aria-label={label}
                   placeholder={label}
                   value={query}
                   onChange={(e) => setQuery(e.target.value)}/>
        </form>
    </>;
}

export default SearchBar;